<template>
  <div id="wrapper">
    <!-- <contract-side-bar index="1" /> -->
    <div id="content-wrapper" class="page">
      <div class="container-fluid">
        <form @submit.prevent="submitItem" autocomplete="off">
          <div class="mb-4">
            <a href="#" @click.prevent="goBack">
              <i class="fas fa-arrow-left"></i>
              Back
              <!-- Quay lại -->
            </a>
            <div class="float-right">
              <button
                class="btn btn-primary"
                type="submit"
                :disabled="isStoring"
              >
                Save
                <!-- Lưu -->
              </button>
            </div>
          </div>
          <b-card class="mt-3">
            <!-- <b-form autocomplete="off" @submit="submitItem($evemt)"> -->
            <b-row class="mb-4">
              <b-col cols>
                <b>
                  Contract information
                  <!-- Thông tin hợp đồng -->
                </b>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">
                  Project
                  <!-- Dự án -->
                </label>
                <code>*</code>
              </b-col>
              <b-col cols="9">
                <b-form-input v-model="item.tieude" required></b-form-input>
              </b-col>
              <b-col cols="1"></b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">
                  Department
                  <!-- Phòng ban -->
                </label>
                <code>*</code>
              </b-col>
              <b-col cols="3">
                <b-form-select
                  v-model="item.departmentid"
                  :options="departments"
                  value-field="id"
                  text-field="tendonvi"
                  required
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled
                      >-- Please select Department --</b-form-select-option
                    >
                  </template>
                </b-form-select>
              </b-col>
              <b-col cols="1"></b-col>
              <b-col cols="2">
                <label class="mr-2">
                  Contract Type
                  <!-- Loại hình -->
                </label>
              </b-col>
              <b-col cols="3">
                <b-form-select
                  id="loaihinhhopdong"
                  v-model="item.loaihinhhopdong"
                  :options="optionsLoaihinhhopdong"
                  value-field="id"
                  text-field="pickListValue"
                >
                </b-form-select>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">
                  Contract ID
                  <!-- Số hợp đồng -->
                </label>
              </b-col>
              <b-col cols="3">
                <b-form-input v-model="item.sohopdong"></b-form-input>
              </b-col>
              <b-col cols="1"></b-col>
              <b-col cols="2">
                <label class="mr-2">
                  Contract signing date
                  <!-- Ngày ký hợp đồng -->
                </label>
              </b-col>
              <b-col cols="3">
                <vue-datepicker-local
                  style="width: 100%"
                  v-model="item.ngayky"
                  :local="local"
                  clearable
                  format="DD/MM/YYYY"
                />
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">
                  Scope of work
                  <!-- Phạm vi công việc -->
                </label>
              </b-col>
              <b-col cols="3">
                <b-form-input v-model="item.phamvicongviec"></b-form-input>
              </b-col>
              <b-col cols="1" />
              <b-col cols="2">
                <label class="mr-2">
                  Contract Value
                  <!-- Giá trị hợp đồng -->
                </label>
              </b-col>
              <!-- <code>*</code> -->
              <b-col cols="3">
                <my-currency-input
                  v-model="item.giatrihopdong"
                  type="number"
                  required
                />
              </b-col>
            </b-row>
            <!-- <b-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">Từ ngày (ngày quay)</label>
              </b-col>
              <b-col cols="3">
                <vue-datepicker-local style="width: 100%"
                  v-model="item.ngaybatdau"
                  :local="local"
                  clearable
                  format="DD/MM/YYYY"
                />
              </b-col>
              <b-col cols="1"></b-col>
              <b-col cols="2">
                <label class="mr-2">Tới ngày</label>
              </b-col>
              <b-col cols="3">
                <vue-datepicker-local style="width: 100%"
                  v-model="item.ngayketthuc"
                  :local="local"
                  clearable
                  format="DD/MM/YYYY"
                />
              </b-col>
            </b-row> -->

            <!-- @Edit Thanh hide -->
            <!-- <b-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">Thời gian bàn giao sp</label>
              </b-col>
              <b-col cols="3">
                <vue-datepicker-local style="width: 100%"
                  v-model="item.ngaybangiao"
                  :local="local"
                  clearable
                  format="DD/MM/YYYY"
                />
              </b-col>
              <b-col cols="1"></b-col>
              <b-col cols="2">
                <label class="mr-2">Thời gian bàn giao sp thực tế</label>
              </b-col>
              <b-col cols="3">
                <vue-datepicker-local style="width: 100%"
                  v-model="item.ngaybangiaothucte"
                  :local="local"
                  clearable
                  format="DD/MM/YYYY"
                />
              </b-col>
            </b-row> -->
            <b-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">
                  Period by use
                  <!-- Thời hạn sử dụng -->
                </label>
              </b-col>
              <b-col cols="3">
                <b-form-textarea
                  v-model="item.thoigiansudung"
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </b-col>
              <b-col cols="1"></b-col>
              <b-col cols="2">
                <label class="mr-2">
                  Channel is being used
                  <!-- Kênh được sử dụng -->
                </label>
              </b-col>
              <b-col cols="3">
                <b-form-textarea
                  v-model="item.kenhduocsudung"
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">
                  Exclusivity
                  <!-- Đặc điểm -->
                </label>
              </b-col>
              <b-col cols="3">
                <b-form-select
                  id="dacdiem"
                  v-model="item.dacdiem"
                  :options="optionsDacdiem"
                  value-field="id"
                  text-field="pickListValue"
                >
                </b-form-select>
              </b-col>
              <b-col cols="1"></b-col>
              <b-col cols="2">
                <label class="mr-2">
                  First broadcast date
                  <!-- Ngày phát sóng đầu tiên -->
                </label>
              </b-col>
              <b-col cols="3">
                <vue-datepicker-local
                  style="width: 100%"
                  v-model="item.ngayphatsong"
                  :local="local"
                  clearable
                  format="DD/MM/YYYY"
                />
              </b-col>
            </b-row>
            <br /><br />
            <!-- @Edit THanh hide -->
            <!-- <b-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">Ngày xác nhận nghiệm thu</label>
              </b-col>
              <b-col cols="3">
                <vue-datepicker-local style="width: 100%"
                  v-model="item.ngayxacnhannghiemthu"
                  :local="local"
                  clearable
                  format="DD/MM/YYYY"
                />
              </b-col>
              <b-col cols="1"></b-col>
              <b-col cols="2">
                <label class="mr-2">Giá trị nghiệm thu</label>
              </b-col>
              <b-col cols="3">
                <my-currency-input v-model="item.giatriduocnghiemthu" />
              </b-col>
            </b-row> -->
            <b-row class="mb-4">
              <b-col cols>
                <b>
                  Shooting date
                  <!-- Ngày quay -->
                </b>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">
                  From
                  <!-- Từ ngày -->
                </label>
              </b-col>
              <b-col cols="3">
                <my-date-picker
                  v-model="from_shootingdate_selected"
                  :disabled="true"
                ></my-date-picker>
              </b-col>
              <b-col cols="1">
                <button
                  class="btn btn-secondary"
                  @click.prevent="openDateModal"
                >
                  <i class="fas fa-calendar"></i>
                </button>
              </b-col>
              <b-col cols="2">
                <label class="mr-2">
                  To
                  <!-- Đến ngày -->
                </label>
              </b-col>
              <b-col cols="3">
                <my-date-picker
                  v-model="to_shootingdate_selected"
                  :disabled="true"
                ></my-date-picker>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">
                  Total days:
                  <!-- Số ngày tổng cộng: -->
                </label>
              </b-col>
              <b-col cols="3">
                <b-form-input
                  class="mr-2"
                  v-model="total_date"
                  style="width: 15%;"
                  disabled
                ></b-form-input>
              </b-col>
            </b-row>
            <br /><br />
            <b-row class="mb-4">
              <b-col cols>
                <b>
                  Customer information
                  <!-- Thông tin khách hàng -->
                </b>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">
                  Customer
                  <!-- Khách hàng -->
                </label>
                <!-- <code>*</code> -->
              </b-col>
              <b-col cols="3">
                <multiselect
                  v-model="khachhang_selected"
                  placeholder
                  track-by="id"
                  label="ten"
                  selectedLabel="Đang chọn"
                  select-label="Enter để chọn"
                  deselectLabel="Enter để xóa"
                  :searchable="true"
                  :loading="isLoading"
                  :options="customers"
                  @search-change="findCustomer"
                  @select="unlockNguoiPhuTrach"
                  @remove="lockNguoiPhuTrach"
                  required
                ></multiselect>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">
                  Phone
                  <!-- ĐT -->
                </label>
              </b-col>
              <b-col cols="3">
                <b-form-input v-model="item.dienthoai" readonly></b-form-input>
              </b-col>
              <b-col cols="1"></b-col>
              <b-col cols="2">
                <label class="mr-2">Email</label>
              </b-col>
              <b-col cols="3">
                <b-form-input v-model="item.email" readonly></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">
                  Tax code
                  <!-- MST -->
                </label>
              </b-col>
              <b-col cols="3">
                <b-form-input v-model="item.masothue" readonly></b-form-input>
              </b-col>
              <b-col cols="1"></b-col>
              <b-col cols="2">
                <label class="mr-2">
                  Bank account
                  <!-- Tài khoản NH -->
                </label>
              </b-col>
              <b-col cols="3">
                <b-form-input
                  v-model="item.taikhoannganhang"
                  readonly
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">
                  Address
                  <!-- Địa chỉ -->
                </label>
              </b-col>
              <b-col cols="9">
                <b-form-input v-model="item.diachi" readonly></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">
                  Key Contact
                  <!-- Người phụ trách -->
                </label>
              </b-col>
              <b-col cols="3">
                <multiselect
                  v-model="nguoiphutrach_selected"
                  placeholder
                  track-by="id"
                  label="ten"
                  selectedLabel="Đang chọn"
                  select-label="Enter để chọn"
                  deselectLabel="Enter để xóa"
                  :searchable="true"
                  :loading="isLoading"
                  :options="contacts"
                  @select="
                    (info) => {
                      this.contact_infos.push(info);
                    }
                  "
                  @remove="
                    () => {
                      this.contact_infos = [];
                    }
                  "
                  :disabled="!nguoiphutrach_enabled"
                ></multiselect>
              </b-col>
            </b-row>
            <b-table
              v-if="contact_infos.length > 0"
              bordered
              head-variant="dark"
              hover
              small
              responsive
              :fields="lienheFields"
              :items="contact_infos"
              table-variant="light"
            >
              <template v-slot:cell(ngaysinh)="data">
                {{ data.item.ngaysinh | moment("DD/MM/YYYY") }}
              </template>
            </b-table>
            <b-row class="mb-4">
              <b-col cols="11">
                <div style="flex-grow: 1" />
              </b-col>
            </b-row>
          </b-card>
        </form>

        <!-- MODAL START HERE -->
        <!-- DATE MODAL -->
        <b-modal
          v-model="dateModalShow"
          header-bg-variant="info"
          header-text-variant="light"
          @hidden="closeDateModal"
          size="lg"
          hide-footer
        >
          <template v-slot:modal-title>
            <div>
              Add shooting dates
              <!-- Thêm các đợt quay -->
            </div>
          </template>
          <b-container>
            <form @submit.prevent="storeDate" autocomplete="off">
              <!-- <b-row class="mb-4"> -->
              <!-- No need content -->
              <!-- <b-col cols="2">
              <label class="mr-2">Nội dung</label>
            </b-col>
            <b-col cols="9">
              <b-form-input v-model="dateItem.ten" required></b-form-input>
            </b-col> -->

              <!-- </b-row> -->
              <b-row class="mb-4">
                <b-col cols="2">
                  <!-- <label class="mr-2">Ngày bắt đầu</label> -->
                  <label>
                    Start date
                    <!-- Ngày bắt đầu -->
                  </label>
                </b-col>
                <b-col cols="4">
                  <my-date-picker
                    v-model="ngaybatdau_selected"
                    :required="true"
                  ></my-date-picker>
                </b-col>
                <b-col cols="2">
                  <label style="width: 110%;">
                    End date
                    <!-- Ngày kết thúc -->
                  </label>
                </b-col>
                <b-col cols="4">
                  <my-date-picker
                    v-model="ngayketthuc_selected"
                    :required="true"
                  ></my-date-picker>
                </b-col>
              </b-row>
              <b-table
                bordered
                head-variant="dark"
                hover
                small
                responsive
                striped
                :fields="dateFields"
                :items="dateItems"
                table-variant="light"
              >
                <template v-slot:cell(ngaybatdau)="data">
                  {{ data.item.ngaybatdau | moment("DD/MM/YYYY") }}
                </template>
                <template v-slot:cell(ngayketthuc)="data">
                  {{ data.item.ngayketthuc | moment("DD/MM/YYYY") }}
                </template>
                <template v-slot:cell(action)="data">
                  <!-- <b-link class="text-primary mr-2" href="#" @click="openEditDateModal(data)">
                <i class="fas fa-pencil-alt"></i>
              </b-link> -->
                  <b-link
                    class="text-danger"
                    href="#"
                    @click="deleteDate(data)"
                  >
                    <i class="fas fa-trash"></i>
                  </b-link>
                </template>
              </b-table>
              <b-row class="mb-4">
                <b-col>
                  <div class="form-inline">
                    <div style="flex-grow: 1"></div>
                    <label class="mr-2">
                      Total days:
                      <!-- Số ngày tổng cộng: -->
                    </label>
                    <b-form-input
                      class="mr-2"
                      v-model="total_date"
                      style="width: 8%;"
                      disabled
                    ></b-form-input>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="form-inline">
                    <div style="flex-grow: 1"></div>
                    <b-button class="mr-3" type="submit" variant="info">
                      <i class="fas fa-save mr-2"></i>
                      Save
                      <!-- Lưu -->
                    </b-button>
                    <b-button variant="secondary" @click="closeDateModal">
                      <i class="fas fa-times mr-2"></i>
                      Close
                      <!-- Đóng -->
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </form>
          </b-container>
        </b-modal>
        <!-- END OF DATE MODAL -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
//import ContractSideBar from "../components/Contract/ContractSideBar";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import VueDatepickerLocal from "vue-datepicker-local";
import "vue-datepicker-local/dist/vue-datepicker-local.css";
import MyCurrencyInput from "../components/App/MyCurrencyInput";
import MyDatePicker from "../components/App/MyDatePicker";

export default {
  name: "Contract",
  components: {
    //ContractSideBar,
    Multiselect,
    VueDatepickerLocal,
    MyCurrencyInput,
    MyDatePicker,
  },
  data() {
    return {
      item: {
        id: 0,
        tieude: null,
        sohopdong: null,
        loaihinhhopdong: 0,
        giatrihopdong: 0,
        giatriduocnghiemthu: 0,
        phamvicongviec: "",
        thoigiansudung: null,
        ngayky: "",
        ngaybatdau: "",
        ngayketthuc: "",
        ngaybangiao: "",
        ngaybangiaothucte: "",
        ngayphatsong: "",
        ngayxacnhannghiemthu: "",
        dacdiem: 0,
        kenhduocsudung: "",
        nguoiphutrach: null,

        customerId: null,
        diachi: null,
        dienthoai: null,
        email: null,
        masothue: null,
        taikhoannganhang: null,
        tinhtrang: 0,
        departmentid: null,
      },

      customer_null: {
        id: 0,
        ten: null,
        diachi: null,
        masothue: null,
        doitac: null,
        customerContacts: [],
      },

      customer_item: {
        id: 0,
        ten: null,
        diachi: null,
        masothue: null,
        doitac: null,
        customerContacts: [],
      },

      customer_itemLienHe_null: {
        id: 0,
        ten: null,
        dienthoai: null,
        email: null,
        diachi: null,
        chucdanh: null,
        ngaysinh: null,
      },
      customer_itemLienHe: {
        id: 0,
        ten: null,
        dienthoai: null,
        email: null,
        diachi: null,
        chucdanh: null,
        ngaysinh: null,
      },

      modalShow: false,
      modalLienHeShow: false,
      modalLienHeStatus: 0,
      customer_itemLienHeIdex: -1,

      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ), // months of head
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ), // months of panel
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
      },

      lienheFields: [
        {
          key: "ten",
          label: "Tên",
        },
        {
          key: "chucdanh",
          label: "Chức danh",
        },
        {
          key: "dienthoai",
          label: "Điện thoại",
        },
        {
          key: "email",
          label: "Email",
        },
        {
          key: "ngaysinh",
          label: "Ngày sinh",
        },
        {
          key: "diachi",
          label: "Địa chỉ nhà",
        },
      ],

      tepdinhkemfile: [],
      khachhang_selected: null,
      nguoiphutrach_selected: null,
      ngaybatdau_selected: null,
      ngayketthuc_selected: null,

      from_shootingdate_selected: null,
      to_shootingdate_selected: null,

      nguoiphutrach_enabled: false,

      isLoading: false,
      isStoring: false,

      optionsLoaihinhhopdong: [],
      optionsDacdiem: [],
      customers: [],
      contacts: [],
      contact_infos: [],
      departments: [],

      dateModalShow: false,
      dateItems: [],
      dateFields: [
        {
          key: "ngaybatdau",
          label: "Start date",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "ngayketthuc",
          label: "End date",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "action",
          label: "",
          tdClass: "text-center",
          thStyle: { width: "80px !important" },
        },
      ],
      dateItem: {
        id: 0,
        customercontactid: 0,
        ngaybatdau: "",
        ngayketthuc: "",
        songay: 0,
      },
    };
  },

  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get("/api/picklist/loaihinhhopdong"),
        axios.get("/api/picklist/dacdiem"),
        axios.get("/api/customer"),
        axios.get("/api/department"),
      ])
      .then(
        axios.spread((loaihinhhopdong, dacdiem, customer, department) => {
          next((vm) => {
            vm.getPickList(
              loaihinhhopdong.data,
              dacdiem.data,
              customer.data,
              department.data
            );
          });
        })
      );
  },

  watch: {
    khachhang_selected: function(newValue, oldValue) {
      if (newValue != null) {
        this.item.customerId = newValue.id;
        this.item.dienthoai = newValue.dienthoai;
        this.item.diachi = newValue.diachi;
        this.item.masothue = newValue.masothue;
        this.item.email = newValue.email;
        this.item.taikhoannganhang = newValue.taikhoannganhang;
      } else {
        this.item.customerId = null;
        this.item.dienthoai = null;
        this.item.diachi = null;
        this.item.masothue = null;
        this.item.email = null;
        this.item.taikhoannganhang = null;
      }
    },
  },

  computed: {
    total_date() {
      var total = 0;
      for (var date of this.dateItems) {
        total += date.songay;
      }

      return total;
    },
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    getPickList(loaihinhhopdongs, dacdiems, customers, departments) {
      this.customers = customers;
      this.optionsLoaihinhhopdong = loaihinhhopdongs;
      this.optionsDacdiem = dacdiems;
      this.departments = departments;
      this.customers.splice(0, 0,this.customers.splice(this.customers.findIndex((op) => op.id == 1), 1)[0]);
      this.khachhang_selected = this.customers.find((op) => op.id == 1);
      this.optionsLoaihinhhopdong.unshift({ id: null, pickListValue: "" });
      this.optionsDacdiem.unshift({ id: 0, pickListValue: "" });
    },

    // initData(item, roles) {
    //   if (item) {
    //     this.item = item;
    //     this.name = this.item.name;
    //     this.full_name = this.item.full_name;
    //     const digits = this.item.role_id.split(",");
    //     if (!(digits[0] == "" && digits.length == 1))
    //       this.selectedRoles = digits.map(Number);
    //   }
    //   if (roles) {
    //     this.roles = roles;
    //   }
    // },
    findCustomer(query) {
      if (query && query.length) {
        this.isLoading = true;
        axios.get(`/api/customer?q=${query}`).then((response) => {
          this.isLoading = false;
          this.customers = response.data;
        });
      }
    },
    submitItem() {
      this.isStoring = true;
      if (this.item.id <= 0) {
        this.storeItem();
        return;
      }
      // this.updateItem();
    },
    storeItem() {
      if (
        !(this.item.tieude && this.item.tieude.length) ||
        !(this.item.customerId && this.item.customerId > 0)
        // !(this.item.giatrihopdong && this.item.giatrihopdong > 0)
      ) {
        this.isStoring = false;
        this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {
          timeout: 2000,
        });
      } else {
        const formData = new FormData();
        // for (var i = 0; i < this.tepdinhkemfile.length; i++) {
        //   formData.append("tepdinhkemfile", this.tepdinhkemfile[i]);
        // }
        //if (this.nguoiphutrach_selected != null) this.item.nguoiphutrach = this.nguoiphutrach_selected.id;

        formData.append("tieude", this.item.tieude);
        formData.append("customerId", this.item.customerId);
        formData.append("sohopdong", this.item.sohopdong);
        formData.append("giatrihopdong", this.item.giatrihopdong);
        formData.append("loaihinhhopdong", this.item.loaihinhhopdong);

        formData.append("phamvicongviec", this.item.phamvicongviec);
        formData.append("thoigiansudung", this.item.thoigiansudung);
        if (this.nguoiphutrach_selected != null)
          formData.append("customercontactid", this.nguoiphutrach_selected.id);

        formData.append(
          "ngayky",
          this.item.ngayky == "" ? "" : new Date(this.item.ngayky).toUTCString()
        );
        formData.append(
          "ngaybatdau",
          this.item.ngaybatdau == ""
            ? ""
            : new Date(this.item.ngaybatdau).toUTCString()
        );
        formData.append(
          "ngayketthuc",
          this.item.ngayketthuc == ""
            ? ""
            : new Date(this.item.ngayketthuc).toUTCString()
        );
        formData.append(
          "ngaybangiao",
          this.item.ngaybangiao == ""
            ? ""
            : new Date(this.item.ngaybangiao).toUTCString()
        );
        formData.append(
          "ngaybangiaothucte",
          this.item.ngaybangiaothucte == ""
            ? ""
            : new Date(this.item.ngaybangiaothucte).toUTCString()
        );
        formData.append(
          "ngayphatsong",
          this.item.ngayphatsong == ""
            ? ""
            : new Date(this.item.ngayphatsong).toUTCString()
        );
        formData.append("dacdiem", this.item.dacdiem);
        formData.append("kenhduocsudung", this.item.kenhduocsudung);
        formData.append(
          "ngayxacnhannghiemthu",
          this.item.ngayxacnhannghiemthu == ""
            ? ""
            : new Date(this.item.ngayxacnhannghiemthu).toUTCString()
        );
        formData.append("giatriduocnghiemthu", this.item.giatriduocnghiemthu);
        formData.append("departmentid", this.item.departmentid);

        axios
          .post("/api/customercontract", formData)
          .then((res) => {
            // this.goBack();
            if (!res) {
              this.isStoring = false;
              this.$toast.error("Không tìm thấy contract id !", "Lỗi", {
                timeout: 3000,
              });
              return;
            }
            const payload = {
              customercontractid: res.data,
              shootingdates: this.dateItems,
            };
            axios
              .post("/api/customercontract/multishootingdate", payload)
              .then((res) => {
                this.$router.push({ path: "/contract" });
              })
              .catch((err) => {
                this.isStoring = false;
                this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
              });
          })
          .catch((err) => {
            this.isStoring = false;
            this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
          });
      }
    },
    // updateItem() {
    //   if (
    //     !(this.name && this.name.length) ||
    //     !(this.full_name && this.full_name.length)
    //   ) {
    //     this.isStoring = false;
    //     this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {
    //       timeout: 2000,
    //     });
    //   } else {
    //     // axios
    //     //   .put("/api/user", {
    //     //     id: this.item.id,
    //     //     name: this.name,
    //     //     full_name: this.full_name,
    //     //     password: this.password,
    //     //     selectedRoles: this.selectedRoles,
    //     //   })
    //     //   .then((res) => {
    //     //     this.goBack();
    //     //   })
    //     //   .catch((err) => {
    //     //     this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
    //     //   });
    //     this.isStoring = false;
    //   }
    // },

    unlockNguoiPhuTrach(contact) {
      this.lockNguoiPhuTrach();

      axios
        .get(`/api/customercontact/${contact.id}`)
        .then((res) => {
          this.contacts = res.data;
          this.nguoiphutrach_enabled = true;
        })
        .catch((err) => {
          this.$toast.error(err.response.data + "", "Lỗi", { timeout: 3000 });
        });
    },

    lockNguoiPhuTrach() {
      this.nguoiphutrach_enabled = false;
      this.nguoiphutrach_selected = null;
      this.contact_infos = [];
    },

    date_different(first_date, second_date) {
      var result = 0;

      var first = this.$convert_string_date(first_date);
      var second = this.$convert_string_date(second_date);

      result = (second - first) / 86400000 + 1;

      if (result < 0) return 0;
      return result;
    },

    storeDate() {
      let ngaybd = this.$convert_string_date(this.ngaybatdau_selected);
      let ngaykt = this.$convert_string_date(this.ngayketthuc_selected);

      if (ngaybd > ngaykt) {
        this.$toast.error(
          "Ngày bắt đầu phải nhỏ hơn hoặc bằng ngày kết thúc",
          "Lỗi",
          { timeout: 3000 }
        );
        return;
      }
      let date_item = Object.assign({}, this.dateItem);
      date_item.customercontractid = this.item.id;
      date_item.songay = this.date_different(
        this.ngaybatdau_selected,
        this.ngayketthuc_selected
      );

      date_item.ngaybatdau = this.$convert_string_date(
        this.ngaybatdau_selected
      );
      date_item.ngayketthuc = this.$convert_string_date(
        this.ngayketthuc_selected
      );
      if (this.dateItems.push(date_item)) {
        this.from_shootingdate_selected = new Date(
          Math.min.apply(
            null,
            this.dateItems.map((x) => new Date(x.ngaybatdau))
          )
        ).toDateString("dd/mm/yyyy");
        this.to_shootingdate_selected = new Date(
          Math.max.apply(
            null,
            this.dateItems.map((x) => new Date(x.ngayketthuc))
          )
        ).toDateString("dd/mm/yyyy");
        this.$toast.success("Thêm đợt quay thành công !", "Thành công", {
          timeout: 2000,
        });
      } else
        this.$toast.error("Thêm đợt quay không thành công !", "Lỗi", {
          timeout: 3000,
        });
    },

    deleteDate(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              if (this.dateItems.splice(data.index, 1)) {
                this.from_shootingdate_selected = new Date(
                  Math.min.apply(
                    null,
                    this.dateItems.map((x) => new Date(x.ngaybatdau))
                  )
                ).toDateString("dd/mm/yyyy");
                this.to_shootingdate_selected = new Date(
                  Math.max.apply(
                    null,
                    this.dateItems.map((x) => new Date(x.ngayketthuc))
                  )
                ).toDateString("dd/mm/yyyy");
                this.$toast.success("Xóa đợt quay thành công !", "Thành công", {
                  timeout: 2000,
                });
              } else
                this.$toast.error("Xóa đợt quay không thành công !", "Lỗi", {
                  timeout: 3000,
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },

    openDateModal() {
      this.dateModalShow = true;
    },

    closeDateModal() {
      this.dateModalShow = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
